import { render, staticRenderFns } from "./wxDraftsEdit.vue?vue&type=template&id=844a8856&scoped=true"
import script from "./wxDraftsEdit.vue?vue&type=script&lang=js"
export * from "./wxDraftsEdit.vue?vue&type=script&lang=js"
import style0 from "./wxDraftsEdit.vue?vue&type=style&index=0&id=844a8856&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "844a8856",
  null
  
)

export default component.exports